import type { PaAPI } from '@rialtic/types'
import { ALL_LOB, exclusionStatus } from '../constants'

type ExclusionConnector = Pick<
  PaAPI.Schemas['ExclusionVersionConnectorWithRelationsResponse'],
  'connector_id' | 'status'
>

export const getExclusionStatus = (
  exclusion: {
    exclusion_status: PaAPI.Schemas['ExclusionStatus']
    current_exclusion_version?: {
      exclusion_version_connectors?: ExclusionConnector[]
    }
  },
  connectorId: string,
) => {
  if (exclusion.exclusion_status === exclusionStatus.Draft) {
    return exclusionStatus.Draft
  }

  const connectors =
    exclusion.current_exclusion_version?.exclusion_version_connectors

  return connectorId === ALL_LOB
    ? connectors?.map((connector) => connector.status)
    : connectors?.find((connector) => connector.connector_id === connectorId)
        ?.status
}
